// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2YPQP","content":"LayoutSettings_content__2AR8Q"};